import { useContext } from "react";
import { BaseContext } from "../../context/BaseContext";

export const useBaseContext = () => {
  const context = useContext(BaseContext);

  if (!context) {
    console.error("BaseContext must be used within BaseProvider");
    return;
  }

  return context;
};
